export const TEMP_GATEWAY_HOST = localStorage.getItem("gateway_url");
export const GATEWAY_AUTH_URL = "/rest-api/gateway-token";
export const CATEGORY_URL = `${TEMP_GATEWAY_HOST}/api/admin/categories`;
export const ATTRIBUTE_URL = `${TEMP_GATEWAY_HOST}/api/admin/attributes`;
export const TW_ATTRIBUTE_LIST_URL = "/gateway/inventory/attributes/list";
export const TW_ATTRIBUTE_CREATE_URL = "/gateway/inventory/attributes/create";
export const TW_ATTRIBUTE_EDIT_URL = "/gateway/inventory/attributes/edit";
export const PRODUCTS_URL = `${TEMP_GATEWAY_HOST}/api/admin/products`;
export const PRODUCT_RATES_URL = `${TEMP_GATEWAY_HOST}/api/admin/product-rates`;
export const PRODUCT_SYNC_URL = `${TEMP_GATEWAY_HOST}/api/admin/products/sync`;
export const TW_DIVISION_LIST_URL = `${TEMP_GATEWAY_HOST}/api/admin/divisions`;
export const TW_DIVISION_SYNC_URL = `${TEMP_GATEWAY_HOST}/api/admin/divisions/sync`;
export const COUNTRIES_URL = `${TEMP_GATEWAY_HOST}/api/admin/cms-countries`;
export const COMPANY_LOGO_URL = `${TEMP_GATEWAY_HOST}/api/admin/company-logo`;
export const SITE_CONTENT_URL = `${TEMP_GATEWAY_HOST}/api/admin/site_content`;
export const PRODUCT_PUBLIC_LOCATION = `${TEMP_GATEWAY_HOST}/explore/products`;
export const USER_LIST_URL = `${TEMP_GATEWAY_HOST}/api/admin/users`;
export const TW_DIVISION_CREATE_URL = "/gateway/settings/divisions/create";
export const TW_DIVISION_EDIT_URL = "/gateway/settings/divisions/edit";
export const CONFIGS_URL = `${TEMP_GATEWAY_HOST}/api/admin/configs`;
export const EMAIL_TEST_URL = `${TEMP_GATEWAY_HOST}/api/admin/email/test`;
export const PRODUCT_ACCESS_LIST_URL = `${TEMP_GATEWAY_HOST}/api/admin/product_access`;
export const COUNTRIES_LIST_URL = `${TEMP_GATEWAY_HOST}/api/admin/countries`;
export const REACTIVATION_EMAIL_URL = `${TEMP_GATEWAY_HOST}/api/admin/send_reactivation_email`;
export const HOMEPAGE_TILES_URL = `${TEMP_GATEWAY_HOST}/api/admin/categories/homepage-tiles`;
export const MODAL_LIST_URL = `${TEMP_GATEWAY_HOST}/api/admin/modals`;
export const CAROUSEL_URL = `${TEMP_GATEWAY_HOST}/api/admin/carousels`;
export const CAROUSEL_CONFIG_URL = `${TEMP_GATEWAY_HOST}/api/admin/carousels-configs`;
export const PAGES_URL = `${TEMP_GATEWAY_HOST}/api/admin/pages`;
export const BLOG_URL = `${TEMP_GATEWAY_HOST}/explore/blog`;
export const PRODUCT_IMAGES_URL = `${TEMP_GATEWAY_HOST}/productimages`;
export const MODAL_IMAGES_URL = `${TEMP_GATEWAY_HOST}/modalimages`;
export const CAROUSEL_IMAGES_URL = `${TEMP_GATEWAY_HOST}/carouselimages`;
export const MENU_LIST_URL = `${TEMP_GATEWAY_HOST}/api/admin/navbars`;
export const FOOTER_LIST_URL = `${TEMP_GATEWAY_HOST}/api/admin/footers`;
export const STATIC_MENU_URL = `${TEMP_GATEWAY_HOST}/api/admin/static-menu`;
export const TABLE_VIEW_PAGES_URL = `${TEMP_GATEWAY_HOST}/api/admin/view_pages`;
export const TABLE_VIEW_URL = `${TEMP_GATEWAY_HOST}/api/admin/table_views`;
export const PORT_CUSTOMER_URL = `${TEMP_GATEWAY_HOST}/api/admin/portal_customers`;
export const ATTRIBUTE_VALUES_URL = `${TEMP_GATEWAY_HOST}/api/admin/attribute-values`;
export const RESTRICTION_URL = `${TEMP_GATEWAY_HOST}/api/admin/restrictions`;
export const MARKETING_CODE_URL = `${TEMP_GATEWAY_HOST}/api/admin/marketing-code`;
export const EMAIL_TEMPLATE_URL = `${TEMP_GATEWAY_HOST}/api/admin/email-templates`;
export const PRODUCT_CLASS_GROUP_URL = `${TEMP_GATEWAY_HOST}/api/admin/product-classes`;
export const SERVICE_REQUESTS = `${TEMP_GATEWAY_HOST}/api/admin/service-requests`;
export const LOG_URL = `${TEMP_GATEWAY_HOST}/api/admin/logs`;
export const ORDERS_URL = `${TEMP_GATEWAY_HOST}/api/admin/orders`;
export const AIS_SUMMARIZE_URL = "/rest-api/ais/summarize";
export const COMPANY_FEATURES_URL = "/rest-api/company-features";
export const TRACKING_SCRIPTS_URL = `${TEMP_GATEWAY_HOST}/api/admin/tracking-snippets`;
